import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "./App";

const Pricing = lazy(() => import("./pages/Pricing"));
const QRHunt = lazy(() => import("./pages/QRHunt"));
const OrderPhotos = lazy(() => import("./pages/OrderPhotos"));
const WBCYouth = lazy(() => import("./pages/WBCYouth"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen bg-ink" />}>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/tarifs" element={<Pricing />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/chasse" element={<QRHunt />} />
              <Route path="/commander" element={<OrderPhotos />} />
              <Route path="/wbc-youth" element={<WBCYouth />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </MotionConfig>
    </QueryClientProvider>
  </React.StrictMode>
);
